import React from "react";
import { Link, useLocation } from "react-router-dom";

const ContactMainButtons = () => {
  const location = useLocation();
  console.log(location.pathname); // Outputs the current pathname

  return (
    <div>
      {location.pathname.toLowerCase() === "/thank-you" ? (
        ""
      ) : location.pathname.toLowerCase() === "/pet-grooming-home/delhi-ncr" ? (
        ""
      ) : (
        <div className="contact-button">
          <div className="call-button">
            <Link
              title="Pet Grooming At Home"
              className="call-button-icon"
              target="_blank"
              to="tel:9658-189-189"
            >
              <i class="fa-solid fa-phone-volume"></i>
            </Link>
          </div>

          <div className="whatsapp-button">
            <Link
              title="Cat Grooming Near Me"
              className="whatsapp-button-icon"
              target="_blank"
              to="https://wa.me/+919658189189?text=Hi! I'm Interested in At Home Pet Grooming Service. Please contact me."
            >
              <i class="fa-brands fa-whatsapp"></i>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactMainButtons;
